//#region IMPORTS
import React from 'react';
//redux
import { getConciliationListIncome } from '../../redux/conciliationMonitor.duck';
import { columns } from './conciliationShared';
import ConciliationPartial from './shared/ConciliationPartial';
//#endregion IMPORTS

const codeSapCol = { xs: 6, sm: 6, md: 6, lg: 4 };

const PartialIncome = ({ data }) => (
  <ConciliationPartial
    data={data}
    fetchAction={getConciliationListIncome}
    columns={columns}
    codeSapCol={codeSapCol}
  />
);
export default PartialIncome;
